import { IBorderRadiusProps, IImageTransform } from './image-layer';

export enum MediaType {
    Image = 'image',
    Video = 'video',
    Audio = 'audio',
    Online = 'online',
}

export interface IMediaInfo {
    /** 媒体类型 */
    mediaType: MediaType;
    /** 媒体宽度 */
    naturalWidth: number;
    /** 媒体高度 */
    naturalHeight: number;
    autoplay: boolean;
    loop: boolean;
    controls: boolean;
    borderRadius?: IBorderRadiusProps | null;
    muted?: boolean;
    maskURL?: string;
    poster?: string;
}

export interface IMediaLayerProps extends IMediaInfo {
    url: string;
    /** 变换参数，裁剪，翻转 */
    imageTransform: IImageTransform;
}
